import React from 'react';
import {imageUrl} from 'helpers/ApplicationHelper';

const SmallInfoBox = (props) => { 
    return (
        <div className="small-info-box">
            <img src={imageUrl(props.icon)}/>
            <h3>{props.title}</h3>
            <p dangerouslySetInnerHTML={{__html:props.text}}/>
        </div>
    );
}   

export default SmallInfoBox;